import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero = () => {
    const [startAnim, setStartAnim] = useState(false);

    useEffect(() => {
        setTimeout(() => setStartAnim(true), 100);
    }, []);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 8000,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        pauseOnHover: false,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 500, settings: { slidesToShow: 1 } }
        ]
    };

    const services = [
        {
            title: "Mobile Application",
            // desc: "Comprehensive mobile solutions for enterprise level.", 
            desc: "We provide comprehensive mobile solutions for a wide range of clients ranging from small startups to enterprise level. We have expertise in providing the power of Mobile Apps for businesses",
            icon: "https://cdn-icons-png.flaticon.com/512/3437/3437364.png"
        },
        {
            title: "Web Application",
            //  desc: "Innovative software applications to drive revenue growth.", 
            desc: "We offer product development services for developing, implementing innovative software applications. We build software products that drive revenue growth for our clients.",
            icon: "https://cdn-icons-png.flaticon.com/512/1005/1005141.png"
        },
        {
            title: "Machine-integrated Solutions",
            desc: "Our custom software development service addresses your needs when specific requirements are packaged software. We innovate solutions to satisfy your exact requirements.",
            icon: "https://cdn-icons-png.flaticon.com/512/2103/2103633.png"
        },
        {
            title: "Product Development",
            desc: "We offer product development services for developing, implementing innovative software applications. We build software products that drive revenue growth for our clients.",
            icon: "https://cdn-icons-png.flaticon.com/512/4406/4406323.png"
        },
        {
            title: "Windows Application",
            desc: "GalaxyERP has experience in delivering high-performance Windows and web applications, even for complex functionalities with a visually rich interface and stringent quality.",
            icon: "https://cdn-icons-png.flaticon.com/512/906/906309.png"
        },
        {
            title: "Technical Support",
            desc: "We firmly believe that technical support influences customer buying decisions. Thus, we strive to exceed our clients' expectations by providing excellent product support.",
            // icon: "https://cdn-icons-png.flaticon.com/512/1067/1067566.png"

            icon: "/assets/img/headphones.png"
        }
    ];

    return (
        <section className={`section-plm-key-slider dark ${startAnim ? 'start-text-animation' : ''}`}>
            <div className="hero-container">
                <div className="row-intro">
                    <div className="col">
                        <h1 className="general-title h1-main">Intelligent Software Solutions</h1>
                        <h2 className="general-title">Galaxy ERP connects people, systems and processes to optimize performance.</h2>
                    </div>
                </div>

                {/* Black Shadow Effect mate Wrapper */}
                <div className="carousel-outer-wrapper">
                    <div className="shadow-overlay left"></div>
                    <div className="shadow-overlay right"></div>

                    <div className="carousel-container">
                        <Slider {...settings}>
                            {services.map((item, index) => (
                                <div className="service-card" key={index}>
                                    <div className="icon-box">
                                        <img src={item.icon} alt={item.title} />
                                    </div>
                                    <h4 className="service-name">{item.title}</h4>
                                    <p className="service-text">{item.desc}</p>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;